// Structured Data Schemas for Medical/Telemedicine Platform

export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "MedicalOrganization",
  "name": "Teledoc - Telemedicine Platform",
  "alternateName": "Teledoc",
  "url": "https://teledoc.co.in",
  "logo": "https://teledoc.co.in/static/media/banner_img.69b76a82725c35db4a36.png",
  "description": "Online doctor consultation and telemedicine platform providing 24/7 healthcare services",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN",
    "addressRegion": "India"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+91-XXXX-XXXXXX",
    "contactType": "customer service",
    "availableLanguage": ["English", "Hindi"]
  },
  "sameAs": [
    "https://www.facebook.com/Teledoctelemed",
    "https://www.twitter.com/Teledoc_telemed",
    "https://www.linkedin.com/company/Teledoc-telemed"
  ],
  "medicalSpecialty": [
    "General Practice",
    "Telemedicine",
    "Online Consultation"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Medical Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "MedicalProcedure",
          "name": "Online Doctor Consultation",
          "description": "Virtual consultation with certified doctors"
        }
      }
    ]
  }
});

export const getWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Teledoc - Telemedicine Platform",
  "url": "https://teledoc.co.in",
  "description": "Online doctor consultation and telemedicine platform",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://teledoc.co.in/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  },
  "publisher": {
    "@type": "Organization",
    "name": "Teledoc",
    "logo": {
      "@type": "ImageObject",
      "url": "https://teledoc.co.in/static/media/banner_img.69b76a82725c35db4a36.png"
    }
  }
});

export const getMedicalServiceSchema = () => ({
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": "Teledoc Telemedicine Services",
  "description": "Online doctor consultation and telemedicine services",
  "url": "https://teledoc.co.in",
  "telephone": "+91-XXXX-XXXXXX",
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "IN"
  },
  "openingHours": "Mo-Su 00:00-23:59",
  "medicalSpecialty": [
    "General Practice",
    "Telemedicine",
    "Online Consultation"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Telemedicine Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "MedicalProcedure",
          "name": "General Consultation",
          "description": "Online consultation with general practitioners"
        }
      }
    ]
  }
});

export const getFAQSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const getBreadcrumbSchema = (breadcrumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": breadcrumbs.map((crumb, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": crumb.name,
    "item": crumb.url
  }))
});

export const getAppointmentSchema = (appointment) => ({
  "@context": "https://schema.org",
  "@type": "Event",
  "name": "Medical Consultation Appointment",
  "description": "Online doctor consultation appointment",
  "startDate": appointment.date,
  "endDate": appointment.endTime,
  "location": {
    "@type": "VirtualLocation",
    "name": "Online Consultation",
    "url": appointment.zoom_meeting_link
  },
  "organizer": {
    "@type": "MedicalOrganization",
    "name": "Teledoc",
    "url": "https://teledoc.co.in"
  }
});
